import debounce from '../../core/utils/debounce';
import MegaMenu from '../components/kc-mega-menu';
import MobileMenu from '../components/kc-mobile-menu';
import StickyHeader from '../components/kc-sticky-header';

const InitHeader = (selectors = {}, attributes = {}) => {
  const DELAY = 50;

  const defaultSelectors = {
    header: '.header__wrapper',
    headerInner: '.header__inner',
    mobileMenu: '#mobile-menu__modal',
    openMobileMenuTrigger: '#button__trigger--open_mobile-menu',
    closeMobileMenuTrigger: '#button__trigger--close_mobile-menu',
    submenuTriggers: null,
    megaMenuContainer: '.mega-menu__desktop[data-mega-menu]',
    megaMenuTriggers: '.menu__desktop [data-menu-trigger], .header__icons [data-menu-trigger]',
    megaMenuTargets: '.mega-menu__desktop [data-menu-target]',
    mobileMegaMenuContainer: '.mega-menu__mobile[data-mega-menu]',
    mobileMegaMenuTriggers: '.menu__mobile [data-menu-trigger]',
    mobileMegaMenuTargets: '.mega-menu__mobile [data-menu-target]',
  };

  const defaultAttributes = {
    mobileMenuOpen: 'data-mobile-menu-open',
    megaMenuOpen: 'data-mega-menu-open',
    megaMenuShow: 'data-trigger-show',
    megaMenuActive: 'data-trigger-active',
    mengaMenuOpen: 'data-mega-menu-open',
    stickyHeaderActive: 'data-header-sticky',
    headerHidden: 'data-header-hidden',
    submenuOpen: 'data-submenu-open',
    submenuIndex: 'data-submenu-trigger-index',
    submenuOpen: 'data-submenu-open',
    menuFocused: 'data-menu-focused',
  };

  selectors = { ...defaultSelectors, ...selectors };
  attributes = { ...defaultAttributes, ...attributes };

  window.addEventListener('DOMContentLoaded', event => {
    try {
      const header = document.querySelector(selectors.header);

      if (!header) {
        throw new Error(`Header component with class of ${selectors.header} not found`);
      }

      const stickyHeader = StickyHeader(header, attributes);
      const megaMenu = MegaMenu(header, selectors, attributes);
      const mobileMenu = MobileMenu(header, selectors, attributes);

      stickyHeader.init();
      megaMenu.init();
      mobileMenu.init();

      const resizeHandler = debounce(() => {
        if (window.innerWidth < 992) {
          window.removeEventListener('scroll', stickyHeader.headerOnScroll);
        } else {
          window.addEventListener('scroll', stickyHeader.headerOnScroll, { passive: true });
        }
        mobileMenu.menuOnResize();
      }, DELAY);

      window.addEventListener('resize', () => {
        if (window.innerWidth < 992) {
          megaMenu.closeMegaMenu();
        }

        resizeHandler();
      });
      window.addEventListener('scroll', () => {
        megaMenu.handleScroll();
        stickyHeader.headerOnScroll()
      }, { passive: true });
    } catch (error) {
      console.error(`InitHeader: ${error}`);
    }
  });
};

export default InitHeader;
